import { useCallback } from 'react'
import { useAppDispatch } from 'hooks/useAppDispatch/useAppDispatch'
import { setBreadCrumbMapping } from 'store/actions/breadCrumb.action'

const useSetBreadcrumb = () => {
    const dispatch = useAppDispatch()
    const setBreadcrumb = useCallback(
        (obj: { key: string; value: string }) => {
            dispatch(setBreadCrumbMapping(obj))
        },
        [dispatch],
    )

    return setBreadcrumb
}
export default useSetBreadcrumb
